import {
  FormControl,
  Tooltip,
} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import {
  autoCompleteSelectOptionsFormat,
  extractDataGroup,
  extractSelectedValues,
  selectedListValues,
} from "../../../../utility/helper";
import { listItemProp } from "utility/types";
import MultiSelectAutoCompleteV1, { ChildComponentRef } from "shared-component/autocomplete-checkbox-multiple-v1";
import { useRef, useState } from "react";
import RangeDropdown from "shared-component/range-component";

dayjs.extend(utc);

const CdadHeaderWarrentyClaimsFilterComponent = (props: any) => {
  const childRef = useRef<ChildComponentRef>({ clearSelection: () => { } });
  const [vehicleWarrentyIndicator, setVehicleWarrentyIndicator] = useState<string[]>(extractDataGroup(props.unNestedParamData, "vehicleWarrentyIndicator") ?? []);
  const [vehicleHasClaimIndicator, setVehicleHasClaimIndicator] = useState<string[]>(extractDataGroup(props.unNestedParamData, "vehicleHasClaimIndicator") ?? []);
  const [claimedPartNumber, setClaimedPartNumber] = useState<string[]>(extractDataGroup(props.unNestedParamData, "claimedPartNumber") ?? []);
  const [claimedPartDescription, setClaimedPartDescription] = useState<string[]>(extractDataGroup(props.unNestedParamData, "claimedPartDescription") ?? []);
  const [t1Code, setT1Code] = useState<string[]>(extractDataGroup(props.unNestedParamData, "t1Code") ?? []);
  const [t2Code, setT2Code] = useState<string[]>(extractDataGroup(props.unNestedParamData, "t2Code") ?? []);
  const [fieldReportNumber, setFieldReportNumber] = useState<string[]>(extractDataGroup(props.unNestedParamData, "fieldReportNumber") ?? []);
  const [fieldReportTitle, setFieldReportTitle] = useState<string[]>(extractDataGroup(props.unNestedParamData, "fieldReportTitle") ?? []);
  const [fieldReportStatus, setFieldReportStatus] = useState<string[]>(extractDataGroup(props.unNestedParamData, "fieldReportStatus") ?? []);
  const [monthsInService, setMonthsInService] = useState<any>(extractDataGroup(props.unNestedParamData, "months_in_service") ?? null);
  const [mileage, setMileage] = useState<any>(extractDataGroup(props.unNestedParamData, "mileage") ?? null);

  const handleSelection = (selectedList: listItemProp[], filter: string) => {
    const value: string[] = selectedListValues(selectedList);
    switch (filter) {
      case 'vehicleWarrentyIndicator':
        setVehicleWarrentyIndicator(value);
        props.getUpdatedList({
          title: filter,
          value: value,
        });
        break;
      case 'vehicleHasClaimIndicator':
        setVehicleHasClaimIndicator(value);
        props.getUpdatedList({
          title: filter,
          value: value,
        });
        break;
      case 'claimedPartNumber':
        setClaimedPartNumber(value);
        props.getUpdatedList({
          title: filter,
          value: value,
        });
        break;
      case 'claimedPartDescription':
        setClaimedPartDescription(value);
        props.getUpdatedList({
          title: filter,
          value: value,
        });
        break;
      case 't1Code':
        setT1Code(value);
        props.getUpdatedList({
          title: filter,
          value: value,
        });
        break;
      case 't2Code':
        setT2Code(value);
        props.getUpdatedList({
          title: filter,
          value: value,
        });
        break;
      case 'fieldReportNumber':
        setFieldReportNumber(value);
        props.getUpdatedList({
          title: filter,
          value: value,
        });
        break;
      case 'fieldReportTitle':
        setFieldReportTitle(value);
        props.getUpdatedList({
          title: filter,
          value: value,
        });
        break;
      case 'fieldReportStatus':
        setFieldReportStatus(value);
        props.getUpdatedList({
          title: filter,
          value: value,
        });
        break;
    }
  }

  const updateMISRange = (value: any) => {
    setMonthsInService(value);
    props.getUpdatedList({
      title: "months_in_service",
      value: value,
    });
  }

  const updateMileageRange = (value: any) => {
    setMileage(value);
    props.getUpdatedList({
      title: "mileage",
      value: value,
    });
  }


  return (
    <div style={{ display: "flex", flexWrap: "wrap", paddingTop: "1rem", justifyContent: "flex-start" }}>
      <div className="signalFilterList" style={{ padding: "8px" }}>
        <Tooltip title={vehicleWarrentyIndicator?.length > 0 ? vehicleWarrentyIndicator?.toString() : "Select / Search Vehicle Warranty Indicator"} placement="right">
          <FormControl style={{ width: "210px", fontSize: "12px" }} required>
            <MultiSelectAutoCompleteV1
              items={autoCompleteSelectOptionsFormat(props.vehicleWarrentyIndicator)}
              label="Select / Search Vehicle Warranty Indicator"
              selectAllLabel="Select All"
              onChange={(value: listItemProp[]) => {
                // if (value?.length > 0) handleSelection(value)
                handleSelection(value, 'vehicleWarrentyIndicator')
              }}
              ref={childRef}
              selectedValues={extractSelectedValues(vehicleWarrentyIndicator)}
              disabled={props.vehicleWarrentyIndicator?.length === 0}
            />
          </FormControl>
        </Tooltip>
      </div>
      <div className="signalFilterList" style={{ padding: "8px" }}>
        <Tooltip title={vehicleHasClaimIndicator?.length > 0 ? vehicleHasClaimIndicator?.toString() : "Select / Search Vehicle Has Claim Indicator"} placement="right">
          <FormControl style={{ width: "210px", fontSize: "12px" }} required>
            <MultiSelectAutoCompleteV1
              items={autoCompleteSelectOptionsFormat(props.vehicleHasClaimIndicator)}
              label="Select / Search Vehicle Has Claim Indicator"
              selectAllLabel="Select All"
              onChange={(value: listItemProp[]) => {
                // if (value?.length > 0) handleSelection(value)
                handleSelection(value, 'vehicleHasClaimIndicator')
              }}
              ref={childRef}
              selectedValues={extractSelectedValues(vehicleHasClaimIndicator)}
              disabled={props.vehicleHasClaimIndicator?.length === 0}
            />
          </FormControl>
        </Tooltip>
      </div>
      <div className="signalFilterList" style={{ padding: "8px" }}>
        <Tooltip title={claimedPartNumber?.length > 0 ? claimedPartNumber?.toString() : "Select / Search Claimed Part Number"} placement="right">
          <FormControl style={{ width: "210px", fontSize: "12px" }} required>
            <MultiSelectAutoCompleteV1
              items={autoCompleteSelectOptionsFormat(props.claimedPartNumber)}
              label="Select / Search Claimed Part Number"
              selectAllLabel="Select All"
              onChange={(value: listItemProp[]) => {
                // if (value?.length > 0) handleSelection(value)
                handleSelection(value, 'claimedPartNumber')
              }}
              ref={childRef}
              selectedValues={extractSelectedValues(claimedPartNumber)}
              disabled={props.claimedPartNumber?.length === 0}
            />
          </FormControl>
        </Tooltip>
      </div>
      <div className="signalFilterList" style={{ padding: "8px" }}>
        <Tooltip title={claimedPartDescription?.length > 0 ? claimedPartDescription?.toString() : "Select / Search Claimed Part Description"} placement="right">
          <FormControl style={{ width: "210px", fontSize: "12px" }} required>
            <MultiSelectAutoCompleteV1
              items={autoCompleteSelectOptionsFormat(props.claimedPartDescription)}
              label="Select / Search Claimed Part Description"
              selectAllLabel="Select All"
              onChange={(value: listItemProp[]) => {
                // if (value?.length > 0) handleSelection(value)
                handleSelection(value, 'claimedPartDescription')
              }}
              ref={childRef}
              selectedValues={extractSelectedValues(claimedPartDescription)}
              disabled={props.claimedPartDescription?.length === 0}
            />
          </FormControl>
        </Tooltip>
      </div>
      <div className="signalFilterList" style={{ padding: "8px" }}>
        <Tooltip title={t1Code?.length > 0 ? t1Code?.toString() : "Select / Search T1 Code"} placement="right">
          <FormControl style={{ width: "210px", fontSize: "12px" }} required>
            <MultiSelectAutoCompleteV1
              items={autoCompleteSelectOptionsFormat(props?.t1Code)}
              label="Select / Search T1 Code"
              selectAllLabel="Select All"
              onChange={(value: listItemProp[]) => {
                // if (value?.length > 0) handleSelection(value)
                handleSelection(value, "t1Code")
              }}
              ref={childRef}
              selectedValues={extractSelectedValues(t1Code)}
              disabled={props.t1Code?.length === 0}
            />
          </FormControl>
        </Tooltip>
      </div>
      <div className="signalFilterList" style={{ padding: "8px" }}>
        <Tooltip title={t2Code?.length > 0 ? t2Code?.toString() : "Select / Search T2 Code"} placement="right">
          <FormControl style={{ width: "210px", fontSize: "12px" }} required>
            <MultiSelectAutoCompleteV1
              items={autoCompleteSelectOptionsFormat(props?.t2Code)}
              label="Select / Search T2 Code"
              selectAllLabel="Select All"
              onChange={(value: listItemProp[]) => {
                // if (value?.length > 0) handleSelection(value)
                handleSelection(value, "t2Code")
              }}
              ref={childRef}
              selectedValues={extractSelectedValues(t2Code)}
              disabled={props.t2Code?.length === 0}
            />
          </FormControl>
        </Tooltip>
      </div>
      <div className="signalFilterList" style={{ padding: "8px" }}>
        <Tooltip title={fieldReportNumber?.length > 0 ? fieldReportNumber?.toString() : "Select / Search Field Report Number"} placement="right">
          <FormControl style={{ width: "210px", fontSize: "12px" }} required>
            <MultiSelectAutoCompleteV1
              items={autoCompleteSelectOptionsFormat(props?.fieldReportNumber)}
              label="Select / Search Field Report Number"
              selectAllLabel="Select All"
              onChange={(value: listItemProp[]) => {
                // if (value?.length > 0) handleSelection(value)
                handleSelection(value, "fieldReportNumber")
              }}
              ref={childRef}
              selectedValues={extractSelectedValues(fieldReportNumber)}
              disabled={props.fieldReportNumber?.length === 0}
            />
          </FormControl>
        </Tooltip>
      </div>
      <div className="signalFilterList" style={{ padding: "8px" }}>
        <Tooltip title={fieldReportTitle?.length > 0 ? fieldReportTitle?.toString() : "Select / Search Field Report Title"} placement="right">
          <FormControl style={{ width: "210px", fontSize: "12px" }} required>
            <MultiSelectAutoCompleteV1
              items={autoCompleteSelectOptionsFormat(props?.fieldReportTitle)}
              label="Select / Search Field Report Title"
              selectAllLabel="Select All"
              onChange={(value: listItemProp[]) => {
                // if (value?.length > 0) handleSelection(value)
                handleSelection(value, "fieldReportTitle")
              }}
              ref={childRef}
              selectedValues={extractSelectedValues(fieldReportTitle)}
              disabled={props.fieldReportTitle?.length === 0}
            />
          </FormControl>
        </Tooltip>
      </div>
      <div className="signalFilterList" style={{ padding: "8px" }}>
        <Tooltip title={fieldReportStatus?.length > 0 ? fieldReportStatus?.toString() : "Select / Search Field Report Status"} placement="right">
          <FormControl style={{ width: "210px", fontSize: "12px" }} required>
            <MultiSelectAutoCompleteV1
              items={autoCompleteSelectOptionsFormat(props?.fieldReportStatus)}
              label="Select / Search Field Report Status"
              selectAllLabel="Select All"
              onChange={(value: listItemProp[]) => {
                // if (value?.length > 0) handleSelection(value)
                handleSelection(value, "fieldReportStatus")
              }}
              ref={childRef}
              selectedValues={extractSelectedValues(fieldReportStatus)}
              disabled={props.fieldReportStatus?.length === 0}
            />
          </FormControl>
        </Tooltip>
      </div>
      <div className="signalFilterList" style={{ padding: "8px" }}>
        <Tooltip title={monthsInService ? JSON.stringify(monthsInService) : "Select Months In Service"} placement="top">
          <FormControl style={{ width: "210px", fontSize: "12px" }} required>
            <RangeDropdown value={monthsInService} label="Months In Service" minLabel="Min MIS" maxLabel="Max MIS" updateRangeData={updateMISRange} />
          </FormControl>
        </Tooltip>
      </div>
      <div className="signalFilterList" style={{ padding: "8px" }}>
        <Tooltip title={mileage ? JSON.stringify(mileage) : "Select Mileage"} placement="top">
          <FormControl style={{ width: "210px", fontSize: "12px" }} required>
            <RangeDropdown value={mileage} label="Mileage" minLabel="Min Mileage" maxLabel="Max Mileage" updateRangeData={updateMileageRange} />
          </FormControl>
        </Tooltip>
      </div>
    </div>
  );
};

export default CdadHeaderWarrentyClaimsFilterComponent;
